import 'vant/lib/index.css';
import { createApp } from 'vue'
import App from './App.vue'
import { Form } from 'vant';
import { Field } from 'vant';
import { Button, Radio, RadioGroup } from 'vant';
import { DatePicker, Pagination } from 'vant';

import { Toast } from 'vant';
import router from './router'
const app = createApp(App)
app.use(Form);
app.use(Field);
app.use(Radio);
app.use(RadioGroup);
app.use(Radio);
app.use(Toast);
app.use(Button);
app.use(DatePicker);
app.use(Pagination);
app.use(router);
app.mount('#app')